import { Quote, Star } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      quote: "MyDoor360 completely transformed how I search for properties. Being able to tour homes on my own schedule without an agent was a game-changer. The blockchain verification gave me confidence in every listing.",
      author: "Sarah Mitchell",
      role: "First-time Homebuyer",
      image: "https://images.pexels.com/photos/34129721/pexels-photo-34129721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      rating: 5,
    },
    {
      id: 2,
      quote: "As a real estate investor, the transparency of blockchain title records is invaluable. I can verify ownership history instantly and execute smart contracts without delays. This is the future of real estate.",
      author: "Michael Chen",
      role: "Real Estate Investor",
      image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NTI3NDQ5NXww&ixlib=rb-4.1.0&q=85",
      rating: 5,
    },
    {
      id: 3,
      quote: "The self-guided tour feature is brilliant. I toured 12 properties in one weekend. The background check process was quick, and I felt secure knowing every property is blockchain-verified.",
      author: "Jennifer Adams",
      role: "Relocating Professional",
      image: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      rating: 5,
    },
    {
      id: 4,
      quote: "Finally, a platform that puts buyers first. No pushy agents, no scheduling conflicts. Just pure, efficient property searching with the security of blockchain technology backing every transaction.",
      author: "David Rodriguez",
      role: "Tech Entrepreneur",
      image: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      rating: 5,
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-slate-50" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C04000] mb-4 block">
            Testimonials
          </span>
          <h2 
            className="text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="testimonials-heading"
          >
            What Our Users Say
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Thousands of buyers, sellers, and investors trust MyDoor360 for their real estate transactions.
          </p>
        </div>

        {/* Testimonials Grid - Masonry Style */}
        <div className="columns-1 md:columns-2 lg:columns-2 gap-6 lg:gap-8 space-y-6 lg:space-y-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="break-inside-avoid bg-white rounded-lg p-8 shadow-sm border border-slate-200"
              data-testid={`testimonial-${testimonial.id}`}
            >
              {/* Quote Icon */}
              <div className="w-10 h-10 bg-[#C04000]/10 rounded-lg flex items-center justify-center mb-6">
                <Quote className="w-5 h-5 text-[#C04000]" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#C04000] text-[#C04000]" />
                ))}
              </div>

              {/* Quote */}
              <p className="testimonial-quote text-slate-700 mb-6">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <img
                    src={testimonial.image}
                    alt={testimonial.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p 
                    className="font-semibold text-slate-900"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-slate-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
